import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

import { ReferralProgramConfigurationValues } from '../../referral-program-configuration.types';

export const qualifyingEventTypeSelectOptions: {
  value: ReferralProgramConfigurationValues['qualifyingEvent']['type'];
  label: string;
}[] = [
  { value: 'loyaltyEvent', label: 'Completed Loyalty Event' },
  { value: 'transaction', label: 'Made a Purchase' },
];

export const qualifyingEventCountProductsBySelectOptions: {
  value: Constraint_Purchase_Threshold_Counting_Attribute;
  label: string;
}[] = [
  { value: Constraint_Purchase_Threshold_Counting_Attribute.Quantity, label: 'Product Quantity' },
  { value: Constraint_Purchase_Threshold_Counting_Attribute.MoneyAmount, label: 'Money Amount' },
  { value: Constraint_Purchase_Threshold_Counting_Attribute.UnitsCount, label: 'Units Count' },
];
